/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React, { useEffect, useState } from 'react'
import { Provider } from 'react-redux'

// eslint-disable-next-line import/no-restricted-paths
import { pullConfigFromHtml } from '@/lib/configStore'
// eslint-disable-next-line import/no-restricted-paths
import { configureStore } from '@/store/_setup'

import type { MiddlewareComponent } from '../types'
import type { Store } from 'redux'

const ReduxMiddleware: MiddlewareComponent = ({ children }) => {
  const [store, setStore] = useState<Store | null>(null)

  useEffect(() => {
    const config = pullConfigFromHtml()
    setStore(configureStore({ config }))
  }, [])

  if (!store) {
    return null
  }

  return <Provider store={store}>{children}</Provider>
}

ReduxMiddleware.middleware = {
  displayName: 'ReduxMiddleware',
  dependencies: [],
}

export default ReduxMiddleware
